import { z } from 'zod';
import { ActorSchema } from '../common/actor.schema';

/**
 * Published when an operator activates or deactivates an agent-skill definition
 * (IMM-436.1), in the same unit of work as the status change so the signal can
 * never survive a rolled-back write. IMM-436.2 subscribes: on `deactivated` it
 * pauses every instance of the definition with `paused_reason='OPERATOR'`, on
 * `activated` it clears that pause. Grants and run history are never touched.
 *
 * Both leaves are audited (IMM-1095) against the operator in `actor`. It is
 * optional only so a row already in the outbox across the deploy still parses.
 */
export const SkillDefinitionLifecyclePayloadSchema = z.object({
  // The id the subscriber keys on: an instance references its definition by
  // `skill_definition_id`, so an event carrying only the key would force every
  // consumer to resolve it back through the definition catalogue.
  definitionId: z.uuid(),
  definitionKey: z.string().min(1),
  actor: ActorSchema.optional(),
  occurredAt: z.iso.datetime(),
});

export type SkillDefinitionLifecyclePayload = z.infer<typeof SkillDefinitionLifecyclePayloadSchema>;
